module.exports = __webpack_public_path__ + "img/ABACUS_Logo_White.b6dff3f1.svg";